import { createSelector } from 'reselect';
import { leaderboardSelector } from './simple-selectors';

export const leaderboardBettingToggleSelector = createSelector(
    leaderboardSelector,
    (leaderboard) => leaderboard.bettingToggle
);
